import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const DOCUMENT = derivedThemeValues(() => ({
  scrollbar: {
    width: 'thin',
    color: '#151a1f'
  }
}));